<div class="procedure-dialog-container" data-cy="procedure-selection-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="procedure-selection-header-section">
      <div class="section-header-title" data-cy="procedure-selection-title-text">
        Select procedure
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="procedure-selection-content-section">
      <div style="height: 480px; overflow: auto;" data-cy="procedure-selection-table-container">
        <app-tdo-progress-spinner *ngIf="!proceduresTableModel" data-cy="procedure-selection-loading-spinner"></app-tdo-progress-spinner>
        <app-tdo-table *ngIf="proceduresTableModel" #procedureTable style="flex: 1; min-height: 0;" [isUsePaginator]="true" [pageSizeOptions]="[25, 50, 75, 100]" [tdoTableModel]="proceduresTableModel"
                       (actionClick)="onProcedureTdoTableItemActionClick($event)"
                       (itemSelected)="onProcedureTdoTableItemClick($event)" data-cy="procedure-selection-table"></app-tdo-table>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="procedure-selection-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="procedure-selection-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="procedure-selection-ok-button">Ok</button>
    </div>
  </div>
</div>
